var app = app || angular.module('harriApp');

window.deviceChecker = {

    $xsMaxSize: 767,
    $smMinSize: 768,
    $smMaxSize: 991,
    $mdMaxSize: 992,
    $mdMaxSize: 1199,
    $lgMaxSize: 1200,

    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    IEMobile: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (deviceChecker.Android() || deviceChecker.BlackBerry() || deviceChecker.iOS() || deviceChecker.Opera() || deviceChecker.IEMobile());
    },
    isMobile: function(){
        return !!deviceChecker.any();
    },
    isTinyScreen: function(){
        return $(window).width() < this.$smMinSize;
    },
    isChrome: function () {
        return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    },
    isIOSChrome: function () {
        return this.iOS() && navigator.userAgent.match('CriOS');
    },
    isWindows: function () {
        return (navigator.platform.indexOf('Win') > -1);
    },
    isMacintosh: function () {
        return (navigator.platform.indexOf('Mac') > -1);
    },
    isSafari: function () {
        return /Safari/.test(navigator.userAgent) && /Apple Computer, Inc/.test(navigator.vendor);
    },
    isIE: function () {
        return !!document.documentMode;
    },
    isEdge: function () {
        return window.navigator.userAgent.indexOf("Edge") > -1;
    },
    getEdgeVersion: function () {
        var match = /\b(MSIE |Trident.*?rv:|Edge\/)(\d+)/.exec(navigator.userAgent);
        if (match) {
            return parseInt(match[2]);
        }
        else {
            return -1;
        }
    }
};

app.factory('deviceChecker', [function () {
    return deviceChecker;
}]);

app.factory('initSmartTag', ["DispatcherServices", "$filter", "hUser", "dependenciesLoaderService", "$q", "$state", function (DispatcherServices, $filter, hUser, dependenciesLoaderService, $q, $state) {
    var initSmartTag = {
        'initBanner': function (mobileAppData) {
            var customDesignModifier = 'harri ' + mobileAppData.appName;
            if (window.smartbanner) {
                window.smartbanner.options = {
                    "title": mobileAppData.appDetails.title,
                    "author": $filter('translate')('The Employee Experience Platform'),
                    "price": "GET - ",
                    "priceSuffixApple": $filter('translate')('On the App Store'),
                    "priceSuffixGoogle": $filter('translate')('On Google Play'),
                    "iconApple": mobileAppData.appDetails.icon,
                    "iconGoogle": mobileAppData.appDetails.icon,
                    "button": "VIEW",
                    "buttonUrlApple": mobileAppData.url,
                    "buttonUrlGoogle": mobileAppData.url,
                    "enabledPlatforms": "android,ios",
                    "closeLabel": "Close",
                    "api": "true",
                    "hideTtl": -(new Date().getTime() + (365 * 24 * 60 * 60 * 1000)),
                    "customDesignModifier": customDesignModifier,
                    "disablePositioning": "true",
                };
                window.smartbanner.publish();
            }
            var smartBannerButtons = $('.smartbanner--harri .js_smartbanner__exit, .smartbanner--harri .js_smartbanner__button');

            if (smartBannerButtons && smartBannerButtons.length) {
                smartBannerButtons.on('click', function () {
                    var bannerClosedValue = HStorageManager.get({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'mobile-banner-closed'
                    });
                    var closedBannerAppNames = bannerClosedValue ? bannerClosedValue + ',' : '';
                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'mobile-banner-closed',
                        value: closedBannerAppNames + mobileAppData.appName,
                        expiryDays: 365
                    });
                    initSmartTag.hideMobileBanner();
                });
            }
        },
        'showMobileCover': function(opt){

            if (!hUser.isPrivacyShieldOn()) {
                if (!opt['isEmployer']) {
                    // initial var Android
                    var app_link = 'market://details?id=' + publicConfiguration['mobileAppData']['candidate']['android_app_id'];

                    // iOS
                    if (deviceChecker.iOS()) {
                        app_link = 'http://itunes.apple.com/app/id' + publicConfiguration['mobileAppData']['candidate']['ios_app_id'];
                    }
                }

                var template = DispatcherServices.getNunjucks().render("views/mobile_cover.html", {
                    'app_link': app_link
                });


                $('#mobile-cover').remove();
                $('body').append(template).addClass('modal-open').removeClass('mobile-view');
                HStorageManager.put({
                    storageLevel: HStorageManager.StorageLevels.COOKIES,
                    key: 'candidateAppMobileWelcome',
                    value: true,
                    expiryDays: 365 * 2
                });

                // disable the scrolloing in web page
                $(document).on('touchstart', function (e) {
                    if( !$(e.target).hasClass('btn') ){
                        e.preventDefault();
                    }
                });


                // close the mobile cover page
                $(document).on('touchstart click', '.close-mobile-cover', function () {
                    initSmartTag.closeMobileCover();
                });
            }
            else {
                HStorageManager.put({
                    storageLevel: HStorageManager.StorageLevels.COOKIES,
                    key: 'candidateAppMobileWelcome',
                    value: true,
                    expiryDays: 2
                });
            }

        },
        'closeMobileCover': function(){
            $(document).off('touchstart');
            $(document).off('touchstart click', '.close-mobile-cover');
            $('#mobile-cover').remove();
            $('body').removeClass('modal-open').addClass('mobile-view');
        },
        'showMobileBanner': function (isTeamSchedule) {
            var isLoggedIn = hUser.isLoggedIn();

            if (!HStorageManager.get({
                storageLevel: HStorageManager.StorageLevels.COOKIES,
                key: 'nopromo'
            }) && isLoggedIn) {
                var isEmployer = hUser.isEmployer();
                var currentState = $state.$current.name;
                var isWFM = currentState && (currentState.includes('appLayout.schedule.') || currentState.includes('core-hr') || currentState.includes('communication-hub'));

                var mobileAppData = {};
                var appKey;

                if (deviceChecker.Android()) {
                    mobileAppData['name'] = "google-play-app";
                    appKey = 'android_app_id';
                } else {
                    mobileAppData['name'] = "apple-itunes-app";
                    appKey = 'ios_app_id';
                }

                if (isEmployer) {
                    if (isWFM) {
                        mobileAppData['id'] = publicConfiguration.mobileAppData.harri_live[appKey];
                        mobileAppData['appName'] = 'HARRI_LIVE';
                        mobileAppData['appDetails'] = {
                            title: 'Harri Live',
                            icon: '../../../images/mobile/harrilive.png',
                        };
                    } else {
                        mobileAppData['id'] = publicConfiguration.mobileAppData.employer[appKey];
                        mobileAppData['appName'] = 'HARRI_HIRE';
                        mobileAppData['appDetails'] = {
                            title: 'Harri Hire',
                            icon: '../../../images/mobile/harrihire.png',
                        };
                    }
                } else if (isTeamSchedule) {
                    mobileAppData['id'] = publicConfiguration.mobileAppData.teamlive[appKey];
                    mobileAppData['appName'] = 'TEAM_LIVE';
                    mobileAppData['appDetails'] = {
                        title: 'TeamLive',
                        icon: '../../../images/mobile/teamlive.png',
                    };
                }

                var bannerClosedValue = HStorageManager.get({
                    storageLevel: HStorageManager.StorageLevels.COOKIES,
                    key: 'mobile-banner-closed'
                });
                var closedBannerAppNames = [];
                if (bannerClosedValue) {
                    closedBannerAppNames = bannerClosedValue.split(',');
                }

                if (mobileAppData.id && closedBannerAppNames.indexOf(mobileAppData.appName) === -1) {
                    mobileAppData.url = ((deviceChecker.iOS() ? 'https://itunes.apple.com/us/app/id' : 'https://play.google.com/store/apps/details?id=') + mobileAppData.id);
                    document.querySelector('meta[name="' + mobileAppData.name + '"]').setAttribute("content", "app-id=" + mobileAppData.id);
                    initSmartTag.initBanner(mobileAppData);
                } else if (closedBannerAppNames.indexOf(mobileAppData.appName) > -1) {
                    initSmartTag.hideMobileBanner();
                }
            }
        },
        'checkIfCanShowMobileBanner': function (isTeamSchedule, fromState, toState) {
            var isMobile = window.matchMedia("only screen and (max-width: 760px)");
            if (isMobile && isMobile.matches) {
                var isEmployer = hUser.isEmployer();
                var privacyRoute = publicConfiguration['routes']['/privacy'] && publicConfiguration['routes']['/privacy'].name;
                var termsRoute = publicConfiguration['routes']['/terms'] && publicConfiguration['routes']['/terms'].name;


                if (
                    isEmployer &&
                    toState &&
                    toState.name &&
                    (
                        [
                            'appLayout.harriSH.access-portal.main',
                            'homepage',
                            'appLayout.harriSH.access-portal.user-management',
                            'appLayout.harriSH.access-portal.roles-permissions',
                            'appLayout.harriSH.access-portal.reports',
                            'appLayout.schedule.reports',
                            'appLayout.harriSH.reporting',
                            'appLayout.harriSH.editprofile',
                            'appLayout.schedule.editprofile',
                            'documents',
                            'candidate_offer',
                            'print-schedule',
                            privacyRoute,
                            termsRoute,
                        ]
                            .indexOf(toState.name) > -1 ||
                        toState.name.includes('pms') ||
                        toState.name.includes('lms') ||
                        toState.name.includes('settings') ||
                        (toState.analytics_name && toState.analytics_name === 'dashboard-tts')
                    )
                ) {
                    initSmartTag.hideMobileBanner();
                    return;
                }

                if (isTeamSchedule) {
                    initSmartTag.showMobileBanner(true);
                } else if (isEmployer) {
                    hUser.refresh()
                        .then(function () {
                            initSmartTag.showMobileBanner(false);
                        })
                        .catch(function (err) {
                            console.error(err);
                        });
                }
                $('body').addClass('mobile-view');
            }
        },
        'hideMobileBanner': function () {
            var mobileBanner = $('.smartbanner--harri');
            if (mobileBanner && mobileBanner.length) {
                mobileBanner.remove();
            }
        },
    };

    return initSmartTag;
}]);
